import { createGeoSuggestModel } from '@cian/api-models/suggest/v2/suggest';

import { getHttpApi } from '@cian/http-api/browser';

export interface IGeoNewbuildingSuggestRequestScheme {
  offerType: string;
  regionId: number;
  locationId: number;
  query: string;
  dealType?: 'rent' | 'sale' | 'newobject';
}

export async function getSearchAutocomplete(parameters: IGeoNewbuildingSuggestRequestScheme) {
  try {
    const httpApi = getHttpApi();
    const { response, statusCode } = await httpApi.fetch(
      createGeoSuggestModel({
        parameters,
      }),
    );
    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
